import React, { useEffect, useRef } from 'react'
import mapboxgl from 'mapbox-gl'
import { Box, Typography } from '@mui/material'
import theme from '../../theme'

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN

const CENTER = [-79.20335357721838, -4.035309486997875]
const BOUNDS = [
  [-79.22, -4.05], // [west, south]
  [-79.18, -4.02], // [east, north]
]

const UNLMap = () => {
  const mapContainer = useRef(null)

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: CENTER,
      zoom: 14,
      maxZoom: 16, // máximo permitido
      minZoom: 12, // opcional
      maxBounds: BOUNDS,
    })

    map.on('load', () => {
      map.addSource('unl', {
        type: 'geojson',
        data: '/data/unl_perimeter.geojson',
      })

      map.addLayer({
        id: 'unl-line',
        type: 'line',
        source: 'unl',
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': '#ff6600',
          'line-width': 4,
        },
      })

      const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
        <div style="padding: 20px 18px 13px;">
          <strong>Universidad Nacional de Loja</strong><br>
          <a target="_blank" href="https://www.google.com/maps/place/Universidad+Nacional+de+Loja,+Loja/@-4.0354975,-79.2047202,17z/data=!4m6!3m5!1s0x91cb37810034b14f:0x34718d96e075e27c!8m2!3d-4.0360435!4d-79.2035207!16s%2Fg%2F1td8_5pd?entry=ttu&g_ep=EgoyMDI1MDYyNi4wIKXMDSoASAFQAw%3D%3D">
            Cómo llegar
          </a>
        </div>
      `)

      // Marcador con popup
      new mapboxgl.Marker().setLngLat(CENTER).setPopup(popup).addTo(map)
      popup.addTo(map)
    })

    return () => map.remove()
  }, [])

  return (
    <Box>
      <Typography variant="h6" mb={1} color={theme.palette.text.primary}>
        Universidad Nacional de Loja
      </Typography>
      <Box
        ref={mapContainer}
        sx={{ height: 400, width: '100%', borderRadius: 2, overflow: 'hidden' }}
      />
    </Box>
  )
}

export default UNLMap
